module.exports = __webpack_public_path__ + "img/puzzle1-600.28a1c0c3.png";